import { Component, OnInit, Type, ViewChild, input } from '@angular/core';
import { ICreneau } from 'src/app/entities/creneaux/creneau.interface';
import { DeclarationPosition } from 'src/app/entities/vacation/declaration-position.model';
import { IDeclaration } from 'src/app/entities/vacation/declaration.interface';
import { Declaration } from 'src/app/entities/vacation/declaration.model';
import { IVacation } from 'src/app/entities/vacation/vacation.interface';
import { InvalidMainCouranteElementException } from 'src/app/shared/exceptions/invalid-main-courante-element.exception';
import { Pointage } from '../../entities/creneaux/pointage.model';
import { MainCouranteDeclarationComponent } from './elements/item-card-declaration/declaration.component';
import { MainCourantePointeauComponent } from './elements/item-card-pointeau/pointeau.component';
import { MainCourantePositionComponent } from './elements/item-card-position/position.component';
import { MainCouranteElementDirective } from './main-courante-element.directive';
import { MainCouranteElement } from './main-courante-element.interface';

@Component({
  selector: 'in2-main-courant-element',
  template: `<ng-template in2CrHost></ng-template>`,
  standalone: false,
})
export class MainCouranteElementComponent implements OnInit {
  readonly declaration = input.required<IDeclaration>();
  readonly vacation = input.required<IVacation>();
  readonly creneau = input.required<ICreneau>();
  @ViewChild(MainCouranteElementDirective, { static: true }) public crHost!: MainCouranteElementDirective;

  public ngOnInit(): void {
    const viewContainerRef = this.crHost.viewContainerRef;
    viewContainerRef.clear();

    const crComponent: Type<MainCouranteElement> = this.getComponentForMainCouranteElementType(this.declaration());
    const componentRef = viewContainerRef.createComponent<MainCouranteElement>(crComponent);
    componentRef.setInput('declaration', this.declaration());
    componentRef.setInput('vacation', this.vacation());
    componentRef.setInput('creneau', this.creneau());
  }

  private getComponentForMainCouranteElementType(declaration: IDeclaration): Type<MainCouranteElement> {
    if (declaration instanceof Declaration) {
      return MainCouranteDeclarationComponent;
    } else if (declaration instanceof DeclarationPosition) {
      return MainCourantePositionComponent;
    } else if (declaration instanceof Pointage) {
      return MainCourantePointeauComponent;
    } else {
      throw new InvalidMainCouranteElementException(`Type de declaration inconnue ${declaration.constructor.name}`);
    }
  }
}
